/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ q: NonNullable<unknown> }} Directory_Search_Results_ForInputs */

const en_directory_search_results_for = /** @type {(inputs: Directory_Search_Results_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Results for “${i?.q}”`)
};

const zh_directory_search_results_for = /** @type {(inputs: Directory_Search_Results_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.q}” 的搜索结果`)
};

/**
* | output |
* | --- |
* | "Results for “{q}”" |
*
* @param {Directory_Search_Results_ForInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_search_results_for = /** @type {((inputs: Directory_Search_Results_ForInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Results_ForInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_search_results_for(inputs)
	return zh_directory_search_results_for(inputs)
});
export { directory_search_results_for as "directory.search.results_for" }